import AddonsActionTypes from 'redux/addons/types';

// fetch all addons
export const startFetchAllAddons = () => ({
  type: AddonsActionTypes.START_FETCH_ALL_ADDONS,
});

export const fetchAllAddonsSuccess = (addons) => ({
  type: AddonsActionTypes.FETCH_ALL_ADDONS_SUCCESS,
  payload: addons,
});

export const fetchAllAddonsFailure = (error) => ({
  type: AddonsActionTypes.FETCH_ALL_ADDONS_FAILURE,
  payload: error,
});

// fetch org addons
export const startFetchOrgAddons = () => ({
  type: AddonsActionTypes.FETCH_ORG_ADDONS,
});

export const fetchOrgAddonsSuccess = (addons) => ({
  type: AddonsActionTypes.FETCH_ORG_ADDONS_SUCCESS,
  payload: addons,
});

export const fetchOrgAddonsFailure = (error) => ({
  type: AddonsActionTypes.FETCH_ORG_ADDONS_FAILURE,
  payload: error,
});

// update addons
export const updateAddons = (data, cb) => ({
  type: AddonsActionTypes.UPDATE_ADDON,
  payload: { data, cb },
});

export const updateAddonsSuccess = (addons) => ({
  type: AddonsActionTypes.UPDATE_ADDON_SUCCESS,
  payload: addons,
});

export const updateAddonsFailure = (error) => ({
  type: AddonsActionTypes.UPDATE_ADDON_FAILURE,
  payload: error,
});
